export default __webpack_public_path__ + "static/media/Group_102.a08788a3.svg";